<template>
  <LanguageMenu :languages="clientStore.available_languages" :active="activeLanguage" @select="setLanguage" />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import i18n from '@/i18n'
import LanguageMenu from '@/components/partials/navigation/LanguageMenu.vue'
import { useCoreSocket } from '@/services/socket/core-socket'
import { useClientStore } from '@/stores/client'
import { useProjectStore } from '@/stores/project'
import { resolveAllowedLanguage, type SupportedWidgetLanguage } from '@/helpers/shared'

const coreSocket = useCoreSocket()
const clientStore = useClientStore()
const projectStore = useProjectStore()

const activeLanguage = computed(() => {
  return resolveAllowedLanguage(String(i18n.global.locale.value || ''), clientStore.available_languages)
})

const setLanguage = (selected: string) => {
  const language = selected as SupportedWidgetLanguage
  if (!clientStore.available_languages.includes(language)) {
    return
  }

  i18n.global.locale.value = language
  clientStore.setManualLanguagePreference(language)

  const messageCenter = coreSocket.messageCenter
  if (messageCenter) {
    messageCenter.triggerMessage('set_language', { language })
    messageCenter.refetchLocalizedContent()
  }

  projectStore.updateProjectLanguage(language)
}
</script>
